import React, { useState } from "react";
import "./EditTestimonials.css";

const EditTestimonials = () => {
  const [testimonials, setTestimonials] = useState([
    {
      id: 1,
      imgSrc: "https://i.imgur.com/ObnrCh9.jpeg",
      day: "12",
      monthYear: "Jan, 2024",
      reviewer: "Rajesh Kumar - Customer",
      review:
        "Shrayati's eco-friendly products are amazing! Affordable, biodegradable, and natural—perfect for my sustainable lifestyle. Their commitment to the environment is truly inspiring. Highly recommended!",
    },
    {
      id: 2,
      imgSrc: "https://i.imgur.com/hRrBvPV.jpeg",
      day: "18",
      monthYear: "Feb, 2024",
      reviewer: "Anita Verma - Customer",
      review:
        "I’ve been using Shrayati’s biodegradable products for months now. Excellent quality, and very affordable. It's great to see such dedication to eco-friendly living. Great job, Shrayati",
    },
    {
      id: 3,
      imgSrc: "https://i.imgur.com/aDNF7oC.jpeg",
      day: "25",
      monthYear: "Mar, 2024",
      reviewer: "Suresh Patel - Customer",
      review:
        "Shrayati’s natural products are perfect for my home. I appreciate their focus on sustainability and affordability. They've become my trusted source for eco-friendly essentials",
    },
    {
      id: 4,
      imgSrc: "https://i.imgur.com/zdhtLTd.jpeg",
      day: "10",
      monthYear: "Apr, 2024",
      reviewer: "Pooja Sharma - Customer",
      review:
        "Absolutely love Shrayati’s eco-friendly products! Great quality at reasonable prices. It's wonderful to support a brand that's truly making a positive impact on the environment.",
    },
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedTestimonials = [...testimonials];
    updatedTestimonials[index][field] = value;
    setTestimonials(updatedTestimonials);
  };

  const handleImageChange = (index, file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const updatedTestimonials = [...testimonials];
      updatedTestimonials[index].imgSrc = reader.result; // Updating with base64 URL for preview
      setTestimonials(updatedTestimonials);
    };
    if (file) reader.readAsDataURL(file);
  };

  const moveTestimonial = (index, direction) => {
    const updatedTestimonials = [...testimonials];
    const targetIndex = direction === "prev" ? index - 1 : index + 1;

    if (targetIndex >= 0 && targetIndex < testimonials.length) {
      const temp = updatedTestimonials[index];
      updatedTestimonials[index] = updatedTestimonials[targetIndex];
      updatedTestimonials[targetIndex] = temp;
      setTestimonials(updatedTestimonials);
    }
  };

  const addTestimonial = () => {
    setTestimonials([
      ...testimonials,
      {
        id: testimonials.length + 1,
        imgSrc: "",
        day: "",
        monthYear: "",
        reviewer: "",
        review: "",
      },
    ]);
  };

  const removeTestimonial = (index) => {
    setTestimonials(testimonials.filter((_, i) => i !== index));
  };

  return (
    <div className="edit-about edit-testimonials-container">
      <h2>Edit Testimonials</h2>
      <div className="testimonials-list cards-container">
        {testimonials.map((testimonial, index) => (
          <div key={testimonial.id} className="edit-testimonial edit-card">
            <h3>Testimonial {index + 1}</h3>

            <div className="form-group">
              <div className="test-row">
                <div className="tr-lft">
                  <label>Current Image</label>
                  <div className="current-img">
                    <img src={testimonial.imgSrc} alt="Current Testimonial" />
                  </div>
                  <label>Change Image URL</label>
                  <input
                    type="text"
                    placeholder="Image URL"
                    value={testimonial.imgSrc}
                    onChange={(e) =>
                      handleInputChange(index, "imgSrc", e.target.value)
                    }
                  />
               
                </div>

                <div className="tr-rt">
                  <div className="form-group">
                    <label>Reviewer Name</label>
                    <input
                      type="text"
                      placeholder="Reviewer Name"
                      value={testimonial.reviewer}
                      onChange={(e) =>
                        handleInputChange(index, "reviewer", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Review Text</label>
                    <textarea
                      placeholder="Review Text"
                      value={testimonial.review}
                      onChange={(e) =>
                        handleInputChange(index, "review", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Date (Day)</label>
                    <input
                      type="text"
                      placeholder="Day"
                      value={testimonial.day}
                      onChange={(e) =>
                        handleInputChange(index, "day", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Month & Year</label>
                    <input
                      type="text"
                      placeholder="Month, Year"
                      value={testimonial.monthYear}
                      onChange={(e) =>
                        handleInputChange(index, "monthYear", e.target.value)
                      }
                    />
                  </div>
                  <div className="button-group one-ln-btn">
                    <button
                      type="button"
                      onClick={() => moveTestimonial(index, "prev")}
                      disabled={index === 0}
                      className="move-btn"
                    >
                      Move Up
                    </button>
                    <button
                      type="button"
                      onClick={() => removeTestimonial(index)}
                      className="remove-btn remove-release-btn"
                    >
                      Remove
                    </button>
                    <button
                      type="button"
                      onClick={() => moveTestimonial(index, "next")}
                      disabled={index === testimonials.length - 1}
                      className="move-btn"
                    >
                      Move Down
                    </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="button-group">
        <button type="button" onClick={addTestimonial} className="add-btn add-release-btn">
          Add Testimonial
        </button>
      </div>
      <div className="button-group">
        <button type="button" className="save-btn">
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default EditTestimonials;
